module.exports = __webpack_public_path__ + "static/background_v3-9431372b3d0d4586ada3f155eea64367.jpg";